import { WbStatusComponent } from './../wb-status.component';
import {
  Component,
  AfterViewInit,
  OnInit,
  HostListener,
  ElementRef,
  ViewChild,
  trigger,
  transition,
  state,
  style,
  animate
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { WsService } from '../../utils/network/ws.service';

import { MediaService } from '../peers/media.service';
import { WbService } from '../wb.service';
import { environment } from '../../../environments/environment';
import { SessionManagerService } from '../services/session/session-manager.service';
import { LayoutManagerService } from '../services/layout/layout-manager.service';
import { RecordingManagerService } from '../services/recording/recording-manager.service';
import { ReplayerService, OnReplayer } from './replayer.service';
import { WsService2 } from '../services/ws/ws.service';

declare var $;
declare var chrome;
declare var Tour;

import { Modal } from 'ng2-modal';
import { TranslateService } from 'ng2-translate';
import { ChatParserService } from '../services/chat/chat-parser.service';
import { HbParserService } from '../services/hb/hb-parser.service';
import { HbManagerService } from '../services/hb/hb-manager.service';
import { RoomParserService } from '../services/room/room-parser.service';
import { RoomManagerService } from '../services/room/room-manager.service';
import { ContentParserService } from '../services/content/content-parser.service';
import { MediaParserService } from '../services/media/media-parser.service';
import { MediaManagerService } from '../services/media/media-manager.service';
import { PermissionsManagerService } from '../services/permissions/permissions-manager.service';
import { PermissionsParserService } from '../services/permissions/permissions-parser.service';
import { DesksService } from '../desksmenu/desks.service';
import { LogService } from '../services/log/log.service';
import { NetworkService } from './network.service';
import { SessionParserService } from '../services/session/session-parser.service';
import { UserTypeManagerService } from '../services/usertype/user-type-manager.service';
import { UserTypeParserService } from '../services/usertype/user-type-parser.service';
import { RecordingParserService } from '../services/recording/recording-parser.service';
import { LayoutParserService } from '../services/layout/layout-parser.service';
@Component({
  templateUrl: 'player.component.html',

  styles: [
    `
      .shareScreen {
        top: 10px;
        left: 10px;
        background-color: gray;
        position: absolute;

        width: 100%;
        height: 100%;
        overflow: auto;
        z-index: 1000;
      }
      .peers-panel-videos-wb {
        display: inline-block;
        vertical-align: top;
      }
      .peers-panel-audios-wb {
        display: block;
      }
      .slider {
        position: fixed;
        bottom: 7%;
        width: 80%;
        left: 10%;
        z-index: 2000;
      }

      .anim {
        display: none;
        justify-content: center;
        align-items: center;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        margin: auto;
        width: 50px;
        height: 50px;
        position: absolute;
        z-index: 2001;
      }

      .anim .glyphicon {
        font-size: 50px;
      }
    `
  ],
  providers: [ChatParserService, HbParserService, HbManagerService, RoomParserService, RoomManagerService,  SessionManagerService, SessionParserService,UserTypeManagerService, WsService2,UserTypeParserService,RecordingParserService, RecordingManagerService,LayoutManagerService, LayoutParserService,
    MediaManagerService, MediaParserService,  ContentParserService, ReplayerService,NetworkService,WsService,WbService,MediaService
    ,PermissionsManagerService,PermissionsParserService,DesksService, LogService
  ],
})
export class PlayerComponent implements AfterViewInit, OnInit, OnReplayer {
  constructor(
    public sessionManager: SessionManagerService,
    public route: ActivatedRoute,
    public layoutManagerService: LayoutManagerService,
    public ws: WsService2,
    public recordingManager: RecordingManagerService,
    public replayerService: ReplayerService,
    private translateService: TranslateService
  ) {}
  // boards = []//{wbType: "ALGEBRA", pageId:0}];
  sub: any;
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    console.log('Unload handler');
  }
  @ViewChild('errorModal') errorModal: Modal;
  @ViewChild('loadingModal') loadingModal: Modal;
  @ViewChild('status') statusComponent: WbStatusComponent;
  @ViewChild('recordingHelpModal') recordingHelpModal: Modal;
  teacher = false;
  isAdminToolsComponentVisible() {
    return this.teacher;
  }
  helpPressed() {
    this.recordingHelpModal.open();
  }
  helpChecked = false;
  helpCheckboxSet() {
    return this.helpChecked;
  }
  helpCheck(e) {
    console.log('Checked: ', e);
    window.localStorage.setItem('playerDontShowHelpPopup', e.target.checked);
    this.helpChecked = e.target.checked;
  }
  isPeerToolsComponentVisible() {
    return !this.teacher;
  }
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    console.log('before unload handler');
  }
  handleChange(e) {
    console.log(e.value);
    this.replayerService.seek(e.value / 100);
  }

  getMouseState() {}

  idleTime: number;
  idleInterval: any;
  mouseIdle = false;

  fromContents = true;
  onLoading(loading) {
    if (loading) {
      this.loadingModal.open();
    } else {
      try {
        this.loadingModal.close();
      } catch (error) {}
      if (this.shouldRecord) {
        this.startVideoRecording();
      }
    }
  }

  public startVideoRecording() {
    console.log('hash upload ext', this.hash);
    console.log('sedning message to ', this.replayerService.extId);
    chrome.runtime.sendMessage(this.replayerService.extId, {
      text: 'start',
      hash: this.hash
    });
  }
  public hash;
  public shouldRecord = false;
  ngOnInit() {
    this.helpChecked =
      window.localStorage.getItem('playerDontShowHelpPopup') == 'true';
    window.addEventListener('message', data => {
      console.log(data);
      if (data.data == 'success') {
        console.log('will close');
        window.close();
      }
    });

    var self = this;
    this.replayerService.registerForLoading(this);

    this.sessionManager.boards[0] = { wbType: 'WELCOME' };
    this.sub = this.route.params.subscribe(params => {
      this.recordingManager.showRecordingControls = false;

      if (params['shouldRecord']) {
        this.shouldRecord = true;
        this.recordingManager.shouldRecord = true;
        this.replayerService.shouldRecord = true;
        console.log('will record to video');
        if (params['extId']) {
          this.replayerService.extId = params['extId'];
          console.log('extId', this.replayerService.extId);
        }
      }

      let userHash = params['hash'];
      let recordContainerId = params['recordContainerId'];
      let containerHash = params['containerHash'];
      if (containerHash) {
        this.replayerService.setFromContents(containerHash);
        this.hash = containerHash;

        this.fromContents = true;
      } else {
        this.fromContents = false;
        this.ws.setHash(userHash);

        this.recordingManager.allowRecording = true;
        this.replayerService.setUserHash(userHash);
        this.replayerService.setRecordContainerId(recordContainerId);
        console.log(
          'Got hash ' + userHash + ' and container id ' + recordContainerId
        );
      }

      this.replayerService.registerForReplaying(this);
      if (!this.recordingManager.allowRecording && !this.shouldRecord) {
        console.log('Will set the mouse');
        this.idleInterval = setInterval(function() {
          self.idleTime++;
          if (self.idleTime >= 3) {
            self.mouseIdle = true;
          }
        }, 1000);
        $(document).mousemove(function() {
          self.idleTime = 0;

          self.mouseIdle = false;
        });
      }
      if (!this.recordingManager.allowRecording || this.helpCheckboxSet())
        this.replayerService.play(true);
    });
    this.ws.close();
  }
  startFromHelp() {
    this.replayerService.play(true);
    this.recordingHelpModal.close();
  }
  onStartPlaying() {}
  getFooterLogo() {
    return environment.footerLogo;
  }
  onStopPlaying() {}
  isReady() {}
  ngOnDestroy() {
    this.replayerService.cleanPlayers();
    //this.sub.unsubscribe();
  }
  layout;

  ngAfterViewInit() {
    console.log('after view init');
    if (this.recordingManager.allowRecording && !this.helpCheckboxSet()) {
      this.startTour();
      this.recordingHelpModal.open();
    } else {
      this.replayerService.startPlaying();
    }

    this.layout = this.layoutManagerService.getLayout();
    var self = this;
    // $("#hider").mouseup(function(e){
    //    var p = e.pageX/$("body").width();

    // })
    this.replayerService.registerForError(this);
  }
  showError() {
    this.errorModal.open();
  }
  clicked() {
    $('.anim')
      .fadeIn()
      .fadeOut('1');
    if (this.replayerService.isPlaying()) {
      if (this.recordingManager.allowRecording)
        this.statusComponent.openPlayerManager();
      console.log(new Date(this.replayerService.currentTime).toTimeString());
      this.replayerService.stopPlaying();
    } else {
      this.replayerService.startPlaying();
    }
  }

  tour;
  startTour() {
    this.tour = new Tour({
      storage: false,
      template:
        "<div class='popover tour'>  <div class='arrow'></div><h3 class='popover-title'></h3><div class='popover-content'></div>  <div class='popover-navigation'> <button class='btn btn-default' data-role='prev'>« </button> <span data-role='separator'>|</span> <button class='btn btn-default' data-role='next'> »</button><button class='btn btn-default' data-role='end'>X</button> </div> </div>",
      //backdrop: true,
      // backdropContainer: 'body',
      //backdropPadding: 0,
      steps: [
        {
          // smartPlacement: true,
          placement: 'top',
          element: '#play-button',
          content: 'Use this button to play and pause the video'
          //content: 'Пускаш и спираш видеото от този бутон'
        },
        {
          placement: 'top',
          element: '#slider-step',
          content: this.translateService.instant(
           // 'Спри на позицията, на която искаш да срежеш видеото'
            'Pause at a position you would like to split the video'
          )
        },
        {
          placement: 'top',
          element: '#slider-step',
          content: this.translateService.instant(
            //'Ще се отвори ново меню с бутон РАЗДЕЛИ'
            'Another menu with a button Split will popup'
          )
        }
      ]
    });

    // Initialize the tour
    this.tour.init();
    // Start the tour
    this.tour.start();
  }
}



// WEBPACK FOOTER //
// /app/src/app/wb/player/player.component.ts